<span
  style= "margin-right: 9px;"
  [class]="item.icon"
  [ngClass]="{
    'not-active': !sidebarActive
  }"
  title="{{ item.label | translate }}"
></span>
<strong *ngIf="!sidebarActive">{{ item.label | translate }}</strong>
<span *ngIf="!sidebarActive && item.external" class="fas fa-external-link-alt fa-2x fa-pull-right"></span>